type Carline = {
  [key: string]: {
    [key: string]: string;
  };
};

export const CARLINES: Carline = {
  a3: {
    Sedan: 'a3limo',
    Cabriolet: 'a3cabrio',
  },
  a4: {
    Sedan: 'a4limo',
    'allroad quattro': 'a4aq',
  },
  a5: {
    Coupe: 'a5coupe',
    Sportback: 'a5sb',
    Cabriolet: 'a5cabrio',
  },
  a5new: {
    Sedan: 'a5limo',
  },
  a6: {
    Sedan: 'a6limo',
    'allroad quattro': 'a6aq',
  },
  a6etron: {
    Sportback: 'a6etron',
  },
  a7: {
    Sportback: 'a7sb',
  },
  a8: {
    Sedan: 'a8l',
  },
  s3: {
    Sedan: 's3limo',
  },
  s4: {
    Sedan: 's4limo',
  },
  s5: {
    Coupe: 's5coupe',
    Sportback: 's5sb',
    Cabriolet: 's5cabrio',
  },
  s5new: {
    Sedan: 's5limo',
  },
  s6: {
    Sedan: 's6limo',
  },
  s6etron: {
    Sportback: 's6etron',
  },
  s7: {
    Sportback: 's7sb',
  },
  s8: {
    Sedan: 's8l',
  },
  q3: {
    SUV: 'q3',
  },
  q4: {
    SUV: 'q4',
    Sportback: 'q4sbetron',
  },
  q4etron: {
    SUV: 'q4etron',
    Sportback: 'q4sbetron',
  },
  q5new: {
    SUV: 'allnewq5',
  },
  q5: {
    SUV: 'q5',
    Sportback: 'q5sb',
  },
  q5e: {
    SUV: 'q5tfsie',
    Sportback: 'q5sb',
  },
  q5tfsie: {
    SUV: 'q5tfsie',
  },
  q6etron: {
    SUV: 'q6etron',
    Sportback: 'q6sbetron',
  },
  q7: {
    SUV: 'q7',
  },
  q8: {
    SUV: 'q8',
  },
  sq5new: {
    SUV: 'allnewsq5',
  },
  sq5: {
    SUV: 'sq5',
    Sportback: 'sq5sb',
  },
  sq6etron: {
    SUV: 'sq6etron',
    Sportback: 'sq6sbetron',
  },
  sq7: {
    SUV: 'sq7',
  },
  sq8: {
    SUV: 'sq8',
  },
  q8etron: {
    SUV: 'q8etron',
    Sportback: 'q8sbetron',
  },
  sq8etron: {
    SUV: 'sq8etron',
    Sportback: 'sq8sbetron',
  },
  rs3: {
    Sedan: 'rs3limo',
  },
  rs5: {
    Coupe: 'rs5coupe',
    Sportback: 'rs5sb',
  },
  rs6: {
    Avant: 'rs6avant',
  },
  rs7: {
    Sportback: 'rs7sb',
  },
  rsq8: {
    SUV: 'rsq8',
  },
  r8: {
    Coupe: 'r8',
    Spyder: 'r8spyder',
  },
  tt: {
    Coupe: 'ttcoupe',
    Roadster: 'ttroadster',
  },
  tts: {
    Coupe: 'ttscoupe',
  },
  ttrs: {
    Coupe: 'ttrscoupe',
  },
  etrons: {
    SUV: 'etron',
    Sportback: 'etronsb',
  },
  etron: {
    SUV: 'etron',
    Sportback: 'etronsb',
  },
  etrongt: {
    Sedan: 'etrongt',
  },
  rsetrongt: {
    Sedan: 'rsetrongt',
  },
};

export const CARLINES_CA: Carline = {
  A3: {
    Sedan: 'a3limo',
    Cabriolet: 'a3cabrio',
  },
  A4: {
    Sedan: 'a4limo',
    'allroad quattro': 'a4aq',
  },
  A5: {
    Coupe: 'a5coupe',
    Sportback: 'a5sb',
    Cabriolet: 'a5cabrio',
    Sedan: 'allnewa5',
  },
  A6: {
    Sedan: 'a6limo',
    'allroad quattro': 'a6aq',
  },
  A7: {
    Sportback: 'a7sb',
    Sedan: 'a7sb',
  },
  A8: {
    Sedan: 'a8l',
  },
  S3: {
    Sedan: 's3limo',
  },
  S4: {
    Sedan: 's4limo',
  },
  S5: {
    Coupe: 's5coupe',
    Sportback: 's5sb',
    Cabriolet: 's5cabrio',
  },
  S6: {
    Sedan: 's6limo',
  },
  S7: {
    Sportback: 's7sb',
    Sedan: 's7sb',
  },
  S8: {
    Sedan: 's8l',
  },
  Q3: {
    SUV: 'q3',
  },
  Q4: {
    SUV: 'q4',
    Sportback: 'q4sbetron',
  },
  Q5: {
    SUV: 'q5',
    Sportback: 'q5sb',
  },
  Q5e: {
    SUV: 'q5etron',
  },
  Q6: {
    SUV: 'q6etron',
  },
  Q7: {
    SUV: 'q7',
  },
  Q8: {
    SUV: 'q8',
  },
  SQ5: {
    SUV: 'sq5',
    Sportback: 'sq5sb',
  },
  SQ6: {
    SUV: 'sq6etron',
  },
  SQ7: {
    SUV: 'sq7',
  },
  SQ8: {
    SUV: 'sq8',
  },
  Q8etron: {
    SUV: 'q8etron',
    Sportback: 'q8sbetron',
  },
  SQ8etron: {
    SUV: 'sq8etron',
    Sportback: 'sq8sbetron',
  },
  RS3: {
    Sedan: 'rs3limo',
  },
  RS5: {
    Coupe: 'rs5coupe',
    Sportback: 'rs5sb',
  },
  RS6: {
    Avant: 'rs6avant',
  },
  RS7: {
    Sportback: 'rs7sb',
  },
  RSQ8: {
    SUV: 'rsq8',
  },
  R8: {
    Coupe: 'r8',
    Spyder: 'r8spyder',
  },
  TT: {
    Coupe: 'ttcoupe',
    Roadster: 'ttroadster',
  },
  TTS: {
    Coupe: 'ttscoupe',
  },
  TTRS: {
    Coupe: 'ttrscoupe',
  },
  etrons: {
    SUV: 'etron',
    Sportback: 'etronsb',
  },
  etron: {
    SUV: 'etron',
    Sportback: 'etronsb',
  },
  etrongt: {
    Sedan: 'etrongt',
  },
  rsetrongt: {
    Sedan: 'rsetrongt',
  },
};

export const DAG_LIST = {
  toronto: 'GTA',
  montreal: 'MTL',
  vancouver: 'VAN',
  alberta: 'ALB',
};

export type SortingConfigTypes = {
  [key: string]: string[];
};

export const SORTING_MODEL_US = {
  'q/sq': [
    'q3',
    'q4etron',
    'q5',
    'q5e',
    'sq5',
    'q6etron',
    'sq6etron',
    'q6',
    'q7',
    'sq7',
    'q8',
    'sq8',
    'rsq8',
    'q8etron',
    'sq8etron',
  ],
  'a/s': [
    'a3',
    's3',
    'rs3',
    'a4',
    's4',
    'a5',
    's5',
    'rs5',
    'a6',
    's6',
    'rs6',
    'a6etron',
    's6etron',
    'a7',
    's7',
    'rs7',
    'a8',
    's8',
  ],
  etron: ['etrongt', 'rsetrongt'],
};
export const SORTING_MODEL_CA = {
  'q/sq': ['q3', 'q5new', 'sq5new', 'q5', 'q5e', 'sq5', 'q6', 'q7', 'sq7', 'q8', 'sq8', 'rsq8'],
  'a/s': [
    'a3',
    's3',
    'rs3',
    'a4',
    's4',
    'a5new',
    's5new',
    'a5',
    's5',
    'rs5',
    'a6',
    's6',
    'rs6',
    'a7',
    's7',
    'rs7',
    'a8',
    's8',
  ],
  etron: ['q4etron', 'q6etron', 'sq6etron', 'a6etron', 's6etron', 'etrongt', 'rsetrongt'],
};
